import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { doctor, clinicInfo } from '../data/mockData';

const DoctorProfile = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Meet Our Expert
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Experienced, empathetic, and dedicated to your dental health
          </p>
        </div>
      </section>

      {/* Doctor Profile */}
      <section className="section-padding">
        <div className="container">
          <div className="grid-two-column">
            <div>
              <img 
                src={doctor.image}
                alt={doctor.name}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '600px',
                  objectFit: 'cover',
                  borderRadius: '0px'
                }}
              />
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <h2 className="hero-medium" style={{ marginBottom: '8px' }}>
                {doctor.name}
              </h2>
              <p className="heading-3" style={{ 
                marginBottom: '32px',
                color: 'var(--text-secondary)'
              }}>
                {doctor.designation}
              </p>
              
              <p className="body-large" style={{ 
                marginBottom: '32px',
                lineHeight: '1.8',
                color: 'var(--text-primary)'
              }}>
                {doctor.bio}
              </p>

              <div style={{ marginBottom: '32px' }}>
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>
                  Education & Qualifications
                </h3>
                <ul style={{ 
                  listStyle: 'none',
                  padding: 0,
                  margin: 0
                }}>
                  {doctor.education.map((edu, index) => (
                    <li 
                      key={index}
                      className="body-regular"
                      style={{ 
                        marginBottom: '12px',
                        paddingLeft: '24px',
                        position: 'relative',
                        color: 'var(--text-primary)'
                      }}
                    >
                      <span style={{
                        position: 'absolute',
                        left: '0',
                        top: '8px',
                        width: '6px',
                        height: '6px',
                        background: 'var(--text-primary)',
                        borderRadius: '50%'
                      }} />
                      {edu}
                    </li>
                  ))}
                </ul>
              </div>

              <div style={{ marginBottom: '32px' }}>
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>
                  Specializations
                </h3>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  {doctor.specializations.map((spec, index) => (
                    <span 
                      key={index}
                      className="body-small"
                      style={{
                        padding: '8px 16px',
                        background: 'var(--bg-secondary)',
                        border: '1px solid var(--border-light)',
                        borderRadius: '0px',
                        color: 'var(--text-primary)'
                      }}
                    >
                      {spec}
                    </span>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <Link to="/book-appointment" className="btn-primary">
                  Book Appointment
                </Link>
                <a 
                  href={`tel:${clinicInfo.phone}`}
                  className="btn-secondary"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                >
                  <Phone size={16} />
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section style={{ background: 'var(--bg-secondary)' }} className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Our Vision
            </h2>
            <p className="body-large" style={{ 
              color: 'var(--text-primary)',
              lineHeight: '1.8'
            }}>
              To provide painless dental treatments through advanced technology and an 
              empathetic, human-centered approach that prioritizes patient comfort, trust, 
              and long-term oral health. We believe that quality dental care should be 
              accessible, comfortable, and delivered with genuine compassion.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            background: 'var(--bg-secondary)',
            padding: '64px 48px',
            textAlign: 'center',
            border: '1px solid var(--border-light)',
            borderRadius: '0px'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Experience Painless Dentistry Today
            </h2>
            <p className="body-large" style={{ 
              marginBottom: '32px',
              color: 'var(--text-secondary)'
            }}>
              Schedule your consultation with Dr. Parmila Mahala
            </p>
            <Link to="/book-appointment" className="btn-primary">
              Book Your Appointment
              <ArrowRight size={16} style={{ marginLeft: '8px' }} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DoctorProfile;
